export const RESOURCES_PAGE_URL = '/resources'
